import { ReactNode } from "react";

/**
 * Render light inline markdown (**bold**, *italic*, `code`) from model- or
 * content-authored strings, instead of leaking literal asterisks/backticks into
 * the UI. Plain text with no markers passes straight through unchanged, so it's
 * safe to wrap any string.
 */
export function emphasis(text: string | undefined | null): ReactNode {
  if (!text) return text;
  const parts: ReactNode[] = [];
  const re = /\*\*([^*]+)\*\*|\*([^*\n]+)\*|`([^`]+)`/g;
  let last = 0;
  let k = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1] != null) parts.push(<strong key={k++}>{m[1]}</strong>);
    else if (m[2] != null) parts.push(<em key={k++}>{m[2]}</em>);
    else
      parts.push(
        <code key={k++} className="rounded bg-black/5 px-1 text-[0.95em]">
          {m[3]}
        </code>,
      );
    last = re.lastIndex;
  }
  if (parts.length === 0) return text;
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
